/* BLITZ theme scripts. No dependencies. */
(() => {
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* money */
  const formatMoney = (cents) => {
    const fmt = T.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const withDelims = (num, dec, th, ds) => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(n, 2, '\u00a0', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  };
  T.formatMoney = formatMoney;

  /* focus trap helpers for drawers */
  let lastFocus = null;
  const openDrawer = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    const panel = el.querySelector('[role="dialog"]');
    setTimeout(() => (panel && (panel.querySelector('button, a, input') || panel)).focus({ preventScroll: true }), 50);
  };
  const closeDrawer = (el) => {
    if (!el || !el.hasAttribute('open')) return;
    el.removeAttribute('open');
    document.documentElement.style.overflow = '';
    $$('[aria-expanded="true"][aria-controls="' + el.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('[data-menu][open], [data-cart-drawer][open], [data-search][open]').forEach(closeDrawer);
    // keep Tab inside an open drawer (they are aria-modal)
    if (e.key !== 'Tab') return;
    const open = $('[data-menu][open], [data-cart-drawer][open], [data-search][open]');
    const panel = open && open.querySelector('[role="dialog"]');
    if (!panel) return;
    const f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', panel).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Header dropdowns open on hover or focus (CSS): mirror that in aria-expanded for screen readers.
  $$('.nav__item').forEach((item) => {
    const link = $('.nav__link[aria-haspopup]', item);
    if (!link) return;
    const set = (v) => link.setAttribute('aria-expanded', v ? 'true' : 'false');
    item.addEventListener('mouseenter', () => set(true));
    item.addEventListener('mouseleave', () => set(item.contains(document.activeElement)));
    item.addEventListener('focusin', () => set(true));
    item.addEventListener('focusout', (e) => set(item.contains(e.relatedTarget) || item.matches(':hover')));
  });

  // Language dropdown: close on outside click or Escape.
  document.addEventListener('click', (e) => {
    $$('[data-lang-menu][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-lang-menu][open]').forEach((d) => { d.open = false; d.querySelector('summary').focus(); });
  });

  /* predictive search */
  (() => {
    const sheet = $('[data-search]');
    if (!sheet) return;
    const input = $('[data-search-input]', sheet);
    const form = $('[data-search-form]', sheet);
    const out = $('[data-search-results]', sheet);
    const idle = $('[data-search-idle]', sheet);
    const status = $('[data-search-status]', sheet);
    const intents = $$('[data-intent]', sheet);
    const recentWrap = $('[data-search-recent]', sheet);
    const recentList = $('[data-search-recent-list]', sheet);
    const KEY = 'blitz:recent-searches';
    const cache = new Map();
    let ctrl = null;
    let timer = null;
    let active = -1;

    const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    const recent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
    const remember = (q) => {
      q = q.trim();
      if (q.length < 2) return;
      const list = [q, ...recent().filter((x) => norm(x) !== norm(q))].slice(0, 5);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
    };
    const renderRecent = () => {
      const list = recent();
      recentWrap.hidden = !list.length;
      recentList.innerHTML = '';
      list.forEach((q) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'pill';
        b.dataset.searchFill = q;
        b.dataset.searchItem = '';
        b.textContent = q;
        recentList.appendChild(b);
      });
    };

    const matchIntent = (q) => {
      const n = norm(q);
      if (n.length < 3) return null;
      let best = null;
      let score = 0;
      intents.forEach((el) => {
        el.dataset.intent.split(',').map(norm).filter(Boolean).forEach((k) => {
          // whole words only, so "price" or "service" don't match "ice"
          const hit = (' ' + n + ' ').includes(' ' + k + ' ') ? 100 + k.length : (k.startsWith(n) ? n.length : 0);
          if (hit > score) { score = hit; best = el; }
        });
      });
      return best;
    };

    const items = () => $$('[data-search-item]', sheet).filter((el) => el.offsetParent !== null);
    const setActive = (i) => {
      const list = items();
      list.forEach((el) => el.classList.remove('is-active'));
      active = list.length ? (i + list.length) % list.length : -1;
      if (active > -1) {
        list[active].classList.add('is-active');
        list[active].scrollIntoView({ block: 'nearest' });
      }
    };

    const show = (html) => {
      out.innerHTML = html;
      const empty = !!$('.search-empty', out) && !sheet.classList.contains('has-best');
      out.hidden = false;
      idle.hidden = !empty;
      input.setAttribute('aria-expanded', 'true');
      const n = $$('[data-ps-product]', out).length;
      status.textContent = (T.strings.searchCount || '[n]').replace('[n]', n);
      active = -1;
    };

    const run = (q) => {
      const m = matchIntent(q);
      intents.forEach((el) => (el.hidden = el !== m));
      sheet.classList.toggle('has-best', !!m);
      if (!q.trim()) {
        if (ctrl) ctrl.abort();
        out.hidden = true;
        out.innerHTML = '';
        idle.hidden = false;
        input.setAttribute('aria-expanded', 'false');
        sheet.classList.remove('is-loading');
        renderRecent();
        return;
      }
      const key = norm(q) || q.trim();
      if (cache.has(key)) return show(cache.get(key));
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      sheet.classList.add('is-loading');
      const params = new URLSearchParams({
        q: q.trim(),
        section_id: 'predictive-search',
        'resources[type]': 'product,query,collection,page,article',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,tag,vendor,body',
      });
      fetch(`${T.routes.predictiveSearch}?${params}`, { signal: ctrl.signal })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const html = ($('#shopify-section-predictive-search', doc) || doc.body).innerHTML;
          cache.set(key, html);
          if (input.value.trim() === q.trim()) show(html);
        })
        .catch(() => {})
        .finally(() => sheet.classList.remove('is-loading'));
    };

    const open = () => {
      $$('[data-menu][open]').forEach(closeDrawer);
      openDrawer(sheet);
      $$('[data-search-open][aria-controls]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
      renderRecent();
      setTimeout(() => { input.focus(); input.select(); }, 60);
    };

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-search-open]');
      if (opener) {
        e.preventDefault();
        open();
        return;
      }
      if (!sheet.contains(e.target)) return;
      if (e.target.closest('[data-search-close]')) {
        closeDrawer(sheet);
        return;
      }
      if (e.target.closest('[data-search-clear]')) {
        try { localStorage.removeItem(KEY); } catch (err) { /* ignore */ }
        renderRecent();
        return;
      }
      const fill = e.target.closest('[data-search-fill]');
      if (fill) {
        e.preventDefault();
        input.value = fill.dataset.searchFill;
        input.focus();
        run(input.value);
        return;
      }
      if (e.target.closest('[data-quick-add]')) {
        remember(input.value);
        closeDrawer(sheet);
        return;
      }
      if (e.target.closest('a[href]')) remember(input.value);
    });

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => run(input.value), 140);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(active + (e.key === 'ArrowDown' ? 1 : -1));
      } else if (e.key === 'Enter' && active > -1) {
        const el = items()[active];
        if (el) {
          e.preventDefault();
          el.click();
        }
      }
    });

    form.addEventListener('submit', (e) => {
      if (!input.value.trim()) {
        e.preventDefault();
        return;
      }
      remember(input.value);
    });

    document.addEventListener('keydown', (e) => {
      const t = e.target;
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      if (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      e.preventDefault();
      open();
    });
  })();

  /* mobile menu */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-menu-open]');
    if (open) {
      open.setAttribute('aria-expanded', 'true');
      openDrawer($('[data-menu]'));
      return;
    }
    if (e.target.closest('[data-menu-close]')) closeDrawer($('[data-menu]'));
  });

  /* cart */
  const Cart = {
    drawer: () => $('[data-cart-drawer]'),
    sectionIds() {
      const ids = ['cart-drawer'];
      $$('[data-cart-section]').forEach((el) => ids.push(el.dataset.cartSection));
      return ids;
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.sectionIds(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      return data;
    },
    render(sections) {
      if (!sections) return;
      const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
      if (sections['cart-drawer']) {
        const doc = parse(sections['cart-drawer']);
        const fresh = $('.cart-drawer__panel', doc);
        const panel = $('.cart-drawer__panel');
        if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      }
      $$('[data-cart-section]').forEach((el) => {
        const html = sections[el.dataset.cartSection];
        if (!html) return;
        const fresh = $('[data-cart-section]', parse(html));
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
      this.clearGhosts();
    },
    setCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.dataset.count = count;
        el.textContent = count;
      });
    },
    async refreshCount() {
      try {
        const res = await fetch(T.routes.cart + '.js');
        const cart = await res.json();
        this.setCount(cart.item_count);
      } catch (e) { /* ignore */ }
    },
    async add(items) {
      // A modal (video player, review photos) sits above the drawer: close it first so the drawer is seen and keeps focus.
      $$('dialog[open]').forEach((d) => d.close());
      // Open the drawer right away with a spinner instead of after the server round trip.
      const drawer = $('[data-cart-section]') ? null : this.drawer();
      const panel = drawer && $('.cart-drawer__panel', drawer);
      const wasOpen = drawer && drawer.hasAttribute('open');
      if (drawer && !wasOpen) openDrawer(drawer);
      if (panel) { panel.classList.add('is-busy'); panel.setAttribute('aria-busy', 'true'); }
      try {
        const data = await this.request(T.routes.cartAdd + '.js', { items });
        this.render(data.sections);
        // The drawer section already carries the new count, so skip the extra /cart.js fetch.
        const count = data.sections && data.sections['cart-drawer'] && $('.cart-drawer__count');
        if (count) this.setCount(Number(count.textContent)); else await this.refreshCount();
        if (drawer && drawer.hasAttribute('open') && !panel.contains(document.activeElement)) (panel.querySelector('button, a, input') || panel).focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return data;
      } catch (err) {
        if (drawer && !wasOpen) closeDrawer(drawer);
        throw err;
      } finally {
        if (panel) { panel.classList.remove('is-busy'); panel.removeAttribute('aria-busy'); }
      }
    },
    // A line whose product left the Online Store (drafted, archived, deleted) stays in the cart with no product, can't be
    // removed by key ("Cannot find variant") and only goes when the cart next changes. The drawer hides it and lists the lines
    // to keep in [data-cart-ghosts]: empty the cart and add those back. Once per page view, so a cart that still has ghosts
    // after this can't loop.
    async clearGhosts() {
      const tag = $('[data-cart-ghosts]');
      if (!tag || this.ghostsCleared) return;
      this.ghostsCleared = true;
      try {
        const keep = JSON.parse(tag.textContent);
        let data = await this.request(T.routes.cartClear + '.js', {});
        if (keep.length) data = await this.request(T.routes.cartAdd + '.js', { items: keep });
        this.render(data.sections);
        const count = $('.cart-drawer__count');
        if (count) this.setCount(Number(count.textContent)); else await this.refreshCount();
      } catch (e) { /* the ghosts stay hidden; the next add clears them */ }
    },
    // by line item key, not line number: a line number shifts when an earlier line is removed before the drawer refreshes
    async change(id, quantity) {
      const data = await this.request(T.routes.cartChange + '.js', { id, quantity });
      this.render(data.sections);
      this.setCount(data.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return data;
    }
  };
  T.cart = Cart;
  Cart.clearGhosts();

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && Cart.drawer() && !$('[data-cart-section]')) {
      e.preventDefault();
      openDrawer(Cart.drawer());
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer(Cart.drawer());
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      const line = remove.closest('.cart-line');
      line.style.opacity = '.4';
      Cart.change(remove.dataset.lineRemove, 0).catch((err) => {
        line.style.opacity = '';
        alertError(err, line);
      });
      return;
    }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input', step.closest('[data-qty]'));
      const min = Number(input.min || 0);
      const next = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyStep));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      quick.classList.add('is-loading');
      // data-quick-items (JSON [{id, quantity}]) adds several lines at once: the guide prescription card (product, offer quantity, add-on)
      const items = quick.dataset.quickItems ? JSON.parse(quick.dataset.quickItems) : [{ id: Number(quick.dataset.quickAdd), quantity: 1 }];
      Cart.add(items)
        .catch(alertError)
        .finally(() => quick.classList.remove('is-loading'));
    }
  });

  // one timer per line, so quick taps on two lines both go through
  const qtyTimers = {};
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    const key = input.dataset.lineQty;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(() => {
      delete qtyTimers[key];
      Cart.change(key, Math.max(0, Number(input.value))).catch(alertError);
    }, 350);
  });

  // in the error box of the drawer or cart page the action came from, else of the open drawer or the cart page, else an alert
  function alertError(err, from) {
    const msg = (err && err.message) || T.strings.error;
    const box = (from && from.closest && from.closest('[data-cart-drawer], [data-cart-section]')) || $('[data-cart-drawer][open]') || $('[data-cart-section]');
    const live = box && $('[data-cart-error]', box);
    if (live) {
      live.textContent = msg;
      live.hidden = false;
    } else {
      window.alert(msg);
    }
  }

  /* product form */
  $$('[data-product-form]').forEach((form) => {
    const btn = $('[data-atc]', form);
    const btnText = btn && $('[data-atc-text]', btn);
    const errorBox = $('[data-form-error]', form);
    const planWrap = $('[data-plans]', form);
    const planSelect = $('select[name="selling_plan"]', form);
    const planPicker = $('[data-plan-picker]', form);
    const priceOut = $$('[data-price-out]');
    const shipNote = $('[data-ship-note]', form);

    const current = () => $('input[name="id"]:checked', form) || $('input[name="id"]', form);

    const update = () => {
      const offer = current();
      if (!offer) return;
      const isMain = offer.dataset.main === 'true';
      // selling plans only apply to the product itself
      const type = $('input[name="purchase_type"]:checked', form);
      const subscribing = isMain && !!planSelect && (!type || type.value === 'subscribe');
      if (planWrap) planWrap.hidden = !isMain;
      if (planSelect) planSelect.disabled = !subscribing;
      if (planPicker) planPicker.hidden = !subscribing;
      let price = Number(offer.dataset.price || 0);
      const planOpt = subscribing ? planSelect.selectedOptions[0] : null;
      if (planOpt && planOpt.dataset.price) price = Number(planOpt.dataset.price);
      // a "buy more" offer is the product in a set quantity, with its own total (the saving is an automatic discount)
      const multi = Number(offer.dataset.qty || 0);
      const qty = multi || Number(($('input[name="quantity"]', form) || {}).value || 1);
      const total = multi ? Number(offer.dataset.total) : price * qty;
      priceOut.forEach((el) => (el.textContent = formatMoney(multi ? total : price)));
      // struck price and saving follow the picked offer (a kit has its own compare-at price)
      const compare = planOpt ? 0 : multi ? Number(offer.dataset.compareTotal || 0) : Number(offer.dataset.compare || 0);
      const showSave = compare > (multi ? total : price);
      $$('[data-compare-out]').forEach((el) => { el.hidden = !showSave; if (showSave) el.textContent = formatMoney(compare); });
      $$('[data-save-out]').forEach((el) => {
        el.hidden = !showSave;
        if (showSave) el.textContent = el.dataset.label.replace('[amount]', formatMoney(compare - (multi ? total : price)).replace(/[.,]00(?=\D*$)/, ''));
      });
      if (btnText) btnText.textContent = (offer.dataset.available === 'false' ? T.strings.soldOut : T.strings.addToCart) + (btn.hasAttribute('data-atc-no-price') ? '' : ' · ' + formatMoney(total));
      // kit pages have no price row: the button carries the struck bought-separately price
      if (btnText && btn.hasAttribute('data-atc-was') && showSave && offer.dataset.available !== 'false') {
        const was = document.createElement('s');
        was.className = 'atc__was';
        was.textContent = formatMoney(multi ? compare : compare * qty);
        btnText.append(' ', was);
      }
      if (btn) btn.disabled = offer.dataset.available === 'false';
      if (shipNote) {
        const free = offer.dataset.kit === 'true' || total >= T.freeShipping;
        shipNote.classList.toggle('ship-note--away', !free);
        $('[data-ship-text]', shipNote).innerHTML = free ? T.strings.shipsFree : T.strings.shipsAway.replace('[amount]', formatMoney(T.freeShipping - total));
      }
      $$('[data-store-credit]').forEach((el) => {
        // rounded up to the whole dollar like the Flow workflow (to the cent first), shown without ".00"
        const credit = Math.ceil(Math.round((total * Number(el.dataset.storeCredit)) / 100) / 100) * 100;
        ($('[data-credit-text]', el) || $('span', el)).innerHTML = el.dataset.label.replace('[amount]', formatMoney(credit).replace(/[.,]00(?!\d)/, ''));
      });
    };
    form.addEventListener('change', update);
    form.addEventListener('input', update);
    update();

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (errorBox) errorBox.hidden = true;
      const fd = new FormData(form);
      const item = { id: Number(fd.get('id')), quantity: Number(current().dataset.qty || fd.get('quantity') || 1) };
      const plan = fd.get('selling_plan');
      if (plan) item.selling_plan = Number(plan);
      if (btn) btn.classList.add('is-loading');
      Cart.add([item])
        .catch((err) => {
          if (errorBox) {
            errorBox.textContent = err.message;
            errorBox.hidden = false;
          } else alertError(err);
        })
        .finally(() => btn && btn.classList.remove('is-loading'));
    });
  });

  /* sticky add to cart */
  const sticky = $('[data-sticky-atc]');
  const anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(anchor);
    // back up to the options in the buy box (the offer cards or the variant picker, else the form)
    $('[data-sticky-choose]', sticky)?.addEventListener('click', () => {
      const target = $('[data-options-target]') || $('[data-product-form]');
      if (target) target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* gallery (T.initGallery also wires galleries added later, like the kit quick view) */
  const initGallery = (g) => {
    const track = $('[data-gallery-track]', g);
    const thumbs = $$('[data-gallery-thumb]', g);
    const prev = $('[data-gallery-prev]', g);
    const next = $('[data-gallery-next]', g);
    if (!track) return;
    const count = track.children.length;
    let current = 0;
    // While an arrow or thumb click is sliding the track, the scroll position passes through other slides:
    // ignore those until the slide lands, so quick clicks build on the target, not on a slide in passing.
    let target = null, settle;
    const setCurrent = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
      // keep the active thumb in view, measured against the strip itself (not the page)
      const t = thumbs[i];
      const list = t && t.parentElement;
      if (!list || (list.scrollWidth <= list.clientWidth && list.scrollHeight <= list.clientHeight)) return;
      const lr = list.getBoundingClientRect(), tr = t.getBoundingClientRect();
      list.scrollBy({ left: tr.left - lr.left - (lr.width - tr.width) / 2, top: tr.top - lr.top - (lr.height - tr.height) / 2, behavior: 'smooth' });
    };
    const land = () => { target = null; };
    const go = (i) => {
      i = Math.max(0, Math.min(count - 1, i));
      target = i;
      clearTimeout(settle);
      settle = setTimeout(land, 900); // fallback where scrollend isn't supported
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      if (i !== current) setCurrent(i);
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    if (prev) prev.addEventListener('click', () => go((target ?? current) - 1));
    if (next) next.addEventListener('click', () => go((target ?? current) + 1));
    g.addEventListener('keydown', (e) => {
      if (e.target.closest('input, textarea, video')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go((target ?? current) - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go((target ?? current) + 1); }
    });
    track.addEventListener('scrollend', () => { clearTimeout(settle); land(); });
    let raf;
    track.addEventListener('scroll', () => {
      if (target !== null) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setCurrent(i);
      });
    }, { passive: true });
    // a resize changes the slide width: stay on the same slide
    if ('ResizeObserver' in window) new ResizeObserver(() => { if (target === null) track.scrollTo({ left: track.clientWidth * current }); }).observe(track);
  };
  $$('[data-gallery]').forEach(initGallery);
  T.initGallery = initGallery;

  /* tabs */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        const next = tabs[(i + d + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  });

  /* water hardness checker */
  $$('[data-water]').forEach((box) => {
    const select = $('select', box);
    const knob = $('[data-water-knob]', box);
    const mg = $('[data-water-mg]', box);
    const verdict = $('[data-water-verdict]', box);
    const src = $('[data-water-src]', box);
    const link = $('[data-water-link]', box);
    const max = Number(box.dataset.max || 320);
    const labels = JSON.parse(box.dataset.labels || '{}');
    const update = () => {
      const opt = select.selectedOptions[0];
      if (!opt || !opt.value) return;
      const v = Number(opt.dataset.mg);
      knob.style.left = Math.min(100, (v / max) * 100) + '%';
      mg.textContent = opt.dataset.label || v;
      const level = v >= 180 ? 'very_hard' : v >= 120 ? 'hard' : v >= 60 ? 'moderate' : 'soft';
      verdict.textContent = labels[level] || '';
      if (src) {
        const a = $('a', src);
        if (a && opt.dataset.src) {
          a.href = opt.dataset.src;
          a.textContent = opt.dataset.srcName || opt.dataset.src;
        }
        src.hidden = !opt.dataset.src;
      }
      if (link) {
        link.hidden = !opt.dataset.page;
        if (opt.dataset.page) link.href = opt.dataset.page;
      }
      box.querySelector('[data-water-out]').hidden = false;
    };
    select.addEventListener('change', update);
    update();
  });

  /* build your own kit */
  $$('[data-byo]').forEach((byo) => {
    const tiers = JSON.parse(byo.dataset.tiers || '[]').sort((a, b) => a.min - b.min);
    const boxes = $$('input[type="checkbox"]', byo);
    const out = {
      count: $('[data-byo-count]', byo),
      subtotal: $('[data-byo-subtotal]', byo),
      save: $('[data-byo-save]', byo),
      total: $('[data-byo-total]', byo),
      btn: $('[data-byo-add]', byo),
      hint: $('[data-byo-hint]', byo),
      bar: $('[data-byo-bar]', byo)
    };
    const summary = $('.byo__summary', byo);
    let summaryVisible = false;
    if (out.bar && summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { summaryVisible = entry.isIntersecting; update(); }).observe(summary);
    }
    const tierEls = $$('[data-tier]', byo);
    const min = Number(byo.dataset.min || 2);
    const update = () => {
      const picked = boxes.filter((b) => b.checked);
      const sub = picked.reduce((s, b) => s + Number(b.dataset.price), 0);
      const tier = tiers.filter((t) => picked.length >= t.min).pop();
      const pct = tier ? tier.pct : 0;
      const save = Math.round(sub * pct / 100);
      out.count.textContent = picked.length;
      out.subtotal.textContent = formatMoney(sub);
      out.save.textContent = save ? '-' + formatMoney(save) : formatMoney(0);
      out.total.textContent = formatMoney(sub - save);
      tierEls.forEach((el) => el.classList.toggle('is-active', tier && Number(el.dataset.tier) === tier.min));
      out.btn.disabled = picked.length < min;
      if (out.hint) {
        const next = tiers.find((t) => picked.length < t.min);
        out.hint.textContent = next ? (byo.dataset.hint || '').replace('[n]', next.min - picked.length).replace('[pct]', next.pct) : '';
      }
      if (out.bar) {
        out.bar.hidden = !picked.length || summaryVisible;
        $('[data-byo-bar-count]', out.bar).textContent = (T.strings.byoPicked || '[n]').replace('[n]', picked.length);
        $('[data-byo-bar-total]', out.bar).textContent = formatMoney(sub - save);
        $('[data-byo-bar-hint]', out.bar).textContent = out.hint ? out.hint.textContent : '';
        $('[data-byo-bar-add]', out.bar).disabled = picked.length < min;
      }
    };
    byo.addEventListener('change', update);
    update();
    if (out.bar) $('[data-byo-bar-add]', out.bar).addEventListener('click', () => out.btn.click());
    out.btn.addEventListener('click', () => {
      const items = boxes.filter((b) => b.checked).map((b) => ({ id: Number(b.value), quantity: 1, properties: { _byo: 'yes' } }));
      if (items.length < min) return;
      out.btn.classList.add('is-loading');
      Cart.add(items).catch(alertError).finally(() => out.btn.classList.remove('is-loading'));
    });
  });

  /* reminder signup: turn picked machines into customer tags */
  $$('[data-reminder-form]').forEach((form) => {
    const tags = $('input[name="contact[tags]"]', form);
    const base = tags.value;
    const sync = () => {
      const picked = $$('input[data-machine]:checked', form).map((i) => 'remind-' + i.value);
      tags.value = [base].concat(picked).filter(Boolean).join(',');
    };
    form.addEventListener('change', sync);
    form.addEventListener('submit', sync);
    sync();
  });

  /* order tracking (17track widget) */
  $$('[data-track]').forEach((form) => {
    const lang = form.dataset.lang || 'en';
    const load = () => new Promise((resolve, reject) => {
      if (window.YQV5) return resolve();
      const s = document.createElement('script');
      s.src = 'https://www.17track.net/externalcall.js';
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const num = $('#YQNum', form).value.trim();
      if (!num) return;
      load().then(() => {
        window.YQV5.trackSingle({ YQ_ContainerId: 'YQContainer', YQ_Height: 560, YQ_Fc: '0', YQ_Lang: lang, YQ_Num: num });
      }).catch(() => alertError(new Error(T.strings.error)));
    });
  });

  /* scroll reveal of hash targets inside closed details (FAQ question links like #faq-washing-machine-2) */
  const openHash = () => {
    const target = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target && target.tagName === 'DETAILS') { target.open = true; target.scrollIntoView(); }
  };
  openHash();
  window.addEventListener('hashchange', openHash);
})();

/* External links in articles and pages open in a new tab. They stay followed: citing sources like Health Canada helps trust, and nofollow would not keep link value anyway. */
(() => {
  document.querySelectorAll('.rte a[href^="http"]').forEach((a) => {
    if (a.hostname === location.hostname || /(^|\.)blitzappliances\.com$/.test(a.hostname)) return;
    a.target = '_blank';
    a.relList.add('noopener');
  });
})();

/* Mega menu photos: load them the first time the visitor reaches the menu bar, not on every page view.
   srcset covers 1x to 3x screens; the card is 168px wide.
   theme.js is deferred, so the pointer may already be on the menu when this runs: pointerenter would never fire, so also
   load on any move or tap inside it, and at once if it is already hovered. Listening on document survives the editor re-rendering the header. */
(() => {
  const load = () => {
    document.querySelectorAll('.nav img[data-mega-src]').forEach((img) => {
      img.srcset = img.dataset.megaSrcset;
      img.src = img.dataset.megaSrc;
      img.removeAttribute('data-mega-srcset');
      img.removeAttribute('data-mega-src');
    });
  };
  const events = ['pointerover', 'pointermove', 'focusin'];
  const onEvent = (e) => {
    if (!(e.target instanceof Element) || !e.target.closest('.nav')) return;
    load();
    events.forEach((type) => document.removeEventListener(type, onEvent, true));
    document.addEventListener('shopify:section:load', load);
  };
  if (document.querySelector('.nav:hover, .nav:focus-within')) load();
  events.forEach((type) => document.addEventListener(type, onEvent, { capture: true, passive: true }));
})();

/* Images in closed tabs (kit how-to, kit before and after) and in the bundle offer's "includes" list are lazy, so the browser
   skips them while hidden and they would only start loading on click. Once a section with them comes near the screen and the
   page is idle, switch them to eager so they load in the background and show at once when opened. */
(() => {
  const start = () => {
    const groups = new Map();
    document.querySelectorAll('[role="tabpanel"][hidden] img[loading="lazy"], .offer__incl img[loading="lazy"]').forEach((img) => {
      const box = img.closest('.shopify-section, .offer-list, form') || document.body;
      if (!groups.has(box)) groups.set(box, []);
      groups.get(box).push(img);
    });
    if (!groups.size) return;
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      idle(() => groups.get(e.target).forEach((img) => { img.loading = 'eager'; }));
    }), { rootMargin: '800px 0px' });
    groups.forEach((_, box) => io.observe(box));
  };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();
